/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Lock1Inputs */

const vi_sitesettings_icon_lock1 = /** @type {(inputs: Sitesettings_Icon_Lock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ổ khoá`)
};

/**

* @param {Sitesettings_Icon_Lock1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_lock1 = /** @type {((inputs?: Sitesettings_Icon_Lock1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Lock1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_lock1(inputs)
});
export { sitesettings_icon_lock1 as "siteSettings_icon_lock" }